export const environment = {
    production: true,
    baseUrl: 'https://apps.theguru.co/',
    apiUrl: 'https://apps.theguru.co/api/v1/'
};



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/environments/environment.ts